import { LAB_LSD_CONFIG_ITEM } from './lab-lsd-config.js'
import { LAB_LSD_EXPORT_ITEM } from './lab-lsd-export.js'

/** @type {import('../help-index.js').HelpScreen} */
export const LAB_LSD_HELP = {
  screenId: 'lab-lsd',
  label: 'Libro de Sueldos Digital',
  navPath: 'Laboral → Libro de Sueldos Digital',
  keywords: [
    'lsd', 'libro de sueldos', 'f931', 'afip', 'exportar txt', 'obra social', 'concepto afip',
    'registro 03', 'registro 04', 'validar lsd',
  ].map((k) => k.toLowerCase()),
  status: 'draft',
  summary:
    'Catálogos AFIP (obras sociales y conceptos) y exportación del TXT LSD por período, con validación previa.',
  sidebarItems: [
    LAB_LSD_CONFIG_ITEM,
    LAB_LSD_EXPORT_ITEM,
  ],
}
